export default __webpack_public_path__ + "static/cafe_36012-d8797a7bcdca0c955aba80c6b13ae77b.png";